import CollaborateurViewDetails from "@features/rh/collaborateurs/components/CollaborateurViewDetails.tsx";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Eye } from "lucide-react";

export const Route = createFileRoute("/_app/rh/collaborateurs/$id/view")({
  loader: requirePermission(PERMISSIONS.RH.PERSONNE.VIEW),
  staticData: {
    title: "Détails du Collaborateur",
    icon: Eye,
    permission: PERMISSIONS.RH.PERSONNE.VIEW,
    section: "App",
    showInTab: false,
    showInBreadcrumb: false,
    description: "Voir les détails d'un collaborateur",
  },
  component: CollaborateurViewDetails,
});
